<template>
	<div class="item">
		<img
			class="gif-right"
			:src="require('@/assets/images/board-control/board_control_electrocardiogram.gif')"
			alt="">
		<img
			class="border-img"
			:src="require('@/assets/images/board-control/base.png')"
			alt="">
		<div class="grid">
			<div class="column">
				<div class="border">
					<div class="border-second">
						<div class="id-tab">
							ID: <span>#{{ bulldroid.id }}</span>
						</div>
						<div class="img-wrap">
							<img
								:src="bulldroid.image"
								alt="">
						</div>
						<div class="title">
							{{ bulldroid.name }}
						</div>
						<div class="progress-wrap">
							<div>
								<div class="name">
									<div>
										<img
											:src="require(`@/assets/images/factions-and-levels/${bulldroid.attributes['rarity level']}_banner.png`)"
											alt="">
										<span :class="`text-${bulldroid.attributes['rarity level']}`">{{ bulldroid.attributes['rarity level'] }}</span>
									</div>
									<span
										class="faction"
										:class="`text-${bulldroid.attributes.faction}`">{{ bulldroid.attributes.faction }}</span>
								</div>
							</div>
							<div class="progress">
								<div class="title-progress">
									LAZY SCORE
								</div>
								<div class="progress-square lazy">
									<div
										v-for="n in 10"
										:key="n"
										class="square"
										:class="n <= bulldroid.attributes['lazy score'] ? 'active' : ''" />
								</div>
							</div>
							<div class="progress">
								<div class="title-progress">
									PAWER SCORE
								</div>
								<div class="progress-square pawer">
									<div
										v-for="n in 10"
										:key="n"
										class="square"
										:class="n <= bulldroid.attributes['pawer score'] ? 'active' : ''" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="column">
				<!-- <div class="input-wrap">
					<input
						type="text"
						placeholder="CHANGE NAME">
					<div class="send-change-name">
						<img
							:src="require('@/assets/images/board-control/change_name_button.png')"
							alt="">
						<span>40 K9</span>
					</div>
				</div> -->
				<div class="traits text-wrap">
					<h3>TRAITS</h3>
					<ul class="bulldroid_option_list">
						<li>
							<span class="option_name">SKIN: </span>
							<span class="option_value">{{ bulldroid.attributes.skin }}</span>
						</li>
						<li>
							<span class="option_name">EYES: </span>
							<span class="option_value">{{ bulldroid.attributes.eyes }}</span>
						</li>
						<li>
							<span class="option_name">NOSE: </span>
							<span class="option_value">{{ bulldroid.attributes.noses }}</span>
						</li>
						<li>
							<span class="option_name">MOUTH: </span>
							<span class="option_value">{{ bulldroid.attributes.mouths }}</span>
						</li>
						<li>
							<span class="option_name">BACKGROUND: </span>
							<span class="option_value">{{ bulldroid.attributes.background }}</span>
						</li>
					</ul>
				</div>
				<div class="accessories text-wrap">
					<h3>ACCESSORIES</h3>
					<ul class="bulldroid_option_list">
						<li v-if="bulldroid.attributes['accessories-head']">
							<span class="option_name">HEAD: </span>
							<span class="option_value">{{ bulldroid.attributes['accessories-head'] }}</span>
						</li>
						<li v-if="bulldroid.attributes['accessories-face']">
							<span class="option_name">FACE: </span>
							<span class="option_value">{{ bulldroid.attributes['accessories-face'] }}</span>
						</li>
						<li v-if="bulldroid.attributes['accessories-eyes']">
							<span class="option_name">EYES: </span>
							<span class="option_value">{{ bulldroid.attributes['accessories-eyes'] }}</span>
						</li>
						<li v-if="bulldroid.attributes['accessories-neck']">
							<span class="option_name">NECK: </span>
							<span class="option_value">{{ bulldroid.attributes['accessories-neck'] }}</span>
						</li>
						<li v-if="bulldroid.attributes['accessories-mouth']">
							<span class="option_name">MOUTH: </span>
							<span class="option_value">{{ bulldroid.attributes['accessories-mouth'] }}</span>
						</li>
						<li v-if="bulldroid.attributes['accessories-clothes']">
							<span class="option_name">CLOTHES: </span>
							<span class="option_value">{{ bulldroid.attributes['accessories-clothes'] }}</span>
						</li>
						<li v-if="bulldroid.attributes['accessories-various']">
							<span class="option_name">VARIOUS: </span>
							<span class="option_value">{{ bulldroid.attributes['accessories-various'] }}</span>
						</li>
					</ul>
				</div>
			</div>
			<div class="column flex-block">
				<BulldroidCardStaking
					:bulldroid="bulldroid"
					:account="account" />
				<div class="links">
					<a
						class="raraty"
						:href="`https://rarity.tools/bulldroids-nft/view/${bulldroid.id}`"
						target="_blank"><img
							:src="require('@/assets/images/board-control/rarity-tools.png')"
							alt=""></a>
					<a
						class="ocean"
						:href="`https://opensea.io/assets/${CONTRACT_ADDRESS}/${bulldroid.id}`"
						target="_blank"><img
							:src="require('@/assets/images/board-control/opensea.png')"
							alt=""></a>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import { CONTRACT_ADDRESS } from '@/constants';

import { useWallet } from '@/composables/wallet';

import BulldroidCardStaking from '@/components/BulldroidCardStaking.vue';

defineProps({
	bulldroid: {
		type: Object,
		default: () => {},
	},
});

const {
	account,
} = useWallet();
</script>
